/* @flow */

import { focusOutline } from 'src/shared/app/base/style/token/box';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  a: {
    color: ({ theme }: ThemeFunction) => theme.accentColor,
    // Hide highlight occuring when a link is being tapped on WebKit
    WebkitTapHighlightColor: 'transparent',
    textDecoration: 'none',
    '&:focus': {
      ...focusOutline,
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};
